/**
 * @generated SignedSource<<9ce93814f1a6971ea7597479e6b10734>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserActionWidgetActionQuery$variables = {
  action?: ReadonlyArray<string> | null | undefined;
  id: string;
};
export type UserActionWidgetActionQuery$data = {
  readonly allUserActions: {
    readonly nodes: ReadonlyArray<{
      readonly actionType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly class: {
        readonly id: string;
      } | null | undefined;
      readonly id: string;
      readonly timeStamp: any;
    }> | null | undefined;
  } | null | undefined;
};
export type UserActionWidgetActionQuery = {
  response: UserActionWidgetActionQuery$data;
  variables: UserActionWidgetActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "actionTypeId",
            "variableName": "action"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": [
          {
            "timeStamp": "DESC"
          }
        ]
      }
    ],
    "concreteType": "UserActionNodeConnection",
    "kind": "LinkedField",
    "name": "allUserActions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserActionNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeStamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionTypeNode",
            "kind": "LinkedField",
            "name": "actionType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "class",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserActionWidgetActionQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserActionWidgetActionQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5eeef07ce466e4431ad7e9ce43bdfcc7",
    "id": null,
    "metadata": {},
    "name": "UserActionWidgetActionQuery",
    "operationKind": "query",
    "text": "query UserActionWidgetActionQuery(\n  $id: ID!\n  $action: [ID!]\n) {\n  allUserActions(filter: {userId: $id, actionTypeId: $action}, order: [{timeStamp: DESC}]) {\n    nodes {\n      id\n      timeStamp\n      actionType {\n        id\n        name\n      }\n      class {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b541f1b00fc2bed2f35d27c71f24867";

export default node;
